import { COLOR } from '@src/styles/color';
import React from 'react';
import MoneyBagImg from '@src/assets/images/money-bag.svg';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import { useTranslation } from 'react-i18next';
import PromoBanner from '@src/new-components/PromoBanner';
import { COMMUNITY_VOICE_MONETIZATION_GUIDE_URL } from '@src/configs';

const PromoBannerVoiceCloning = ({ closePromoBannerVoiceCloning }) => {
  const { t } = useTranslation();

  const TitleBannerPromo = () => (
    <Typography
      component="p"
      variant="body-16-medium"
      color={COLOR.black.default}
    >
      {t('titlePromoVoiceCloning')}
    </Typography>
  );

  const DescriptionBannerPromo = () => (
    <Typography
      component="p"
      variant="body-14-regular"
      color={COLOR.descriptionUpload}
    >
      {t('descriptionPromoVoiceCloning')}
    </Typography>
  );

  const ButtonBannerPromo = () => (
    <CommonButton
      variant="outlineSmall"
      customStyle={{
        backgroundColor: 'transparent',
      }}
      textProps={{
        variantText: 'body-14-medium',
        color: COLOR.darkBlue,
      }}
      onClick={() =>
        window.open(COMMUNITY_VOICE_MONETIZATION_GUIDE_URL, '_blank')
      }
    >
      {t('viewTheGuide')}
    </CommonButton>
  );

  return (
    <div style={{ margin: '8px 0px' }}>
      <PromoBanner
        variant="variant-voice-cloning"
        image={MoneyBagImg}
        renderTitle={<TitleBannerPromo />}
        renderDescription={<DescriptionBannerPromo />}
        onClose={() => closePromoBannerVoiceCloning()}
        actionButton={<ButtonBannerPromo />}
      />
    </div>
  );
};

export default PromoBannerVoiceCloning;
